exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".row_16GDEHxe7y {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.row_16GDEHxe7y > * {\n  flex: 1 1 0;\n}\n.row_16GDEHxe7y > *:not(:last-child) {\n  margin-right: 32px;\n}\n.control_JyP81LNPOe {\n  margin-bottom: 16px;\n  width: 320px;\n}\n@media only screen and (min-width: 0px) and (max-width: 760px) {\n  .control_JyP81LNPOe {\n    margin-left: 0;\n    margin-right: 0;\n  }\n}\n.order_1rx3_UJa6D button {\n  padding: 8px;\n}\n", ""]);

// Exports
exports.locals = {
	"row": "row_16GDEHxe7y",
	"control": "control_JyP81LNPOe",
	"order": "order_1rx3_UJa6D"
};